import lime from "../assets/portfolio/lime.png";
import morko from "../assets/portfolio/morko.png";
import leaf from "../assets/portfolio/leaf.png";
import tomato from "../assets/portfolio/tomato.png";
import blackB from "../assets/portfolio/blackbe.png";
import limeTwo from "../assets/portfolio/fruit-lime.png";
import BigMorko4 from "../assets/portfolio/qq5.jpg";
import BigLim3 from "../assets/portfolio/l3.jpg";
import BigLim2 from "../assets/portfolio/l7.jpg";
import BlackB from "../assets/portfolio/blackB.png";
import BigLeaf2 from "../assets/portfolio/ll2.jpg";
import tomato4 from "../assets/portfolio/t4.jpg";
import lime3 from "../assets/portfolio/l5.jpg";
import MidMorkov from "../assets/portfolio/qq2.jpg";
import MidLeaf from "../assets/portfolio/ll1.jpg";
import MidTomat from "../assets/portfolio/t6.jpg";
import MidLime from "../assets/portfolio/l8.jpg";

const porfolios = [
  {
    id: 1,
    date: "December 1, 2022",
    view: "Fruits",
    image: lime,
    middleImg: lime3,
    bigImage: BigLim3,
    client: "Malkolm Corry",
    title: "Green & Tasty Lemon",
    category: "Agriculture , Eco, Fruits",
    text: "But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system, and expound the actual teachings of the great explorer of the truth.",
    service: "Organic Products",
  },
  {
    id: 2,
    date: "November 21, 2022",
    view: "Farmer",
    image: morko,
    middleImg: MidMorkov,
    bigImage: BigMorko4,
    client: "Corry Teylor",
    title: "Organic Carrot",
    category: "Agriculture , Eco, Fruits",
    text: "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.",
    service: "Organic Products",
  },
  {
    id: 3,
    date: "November 11, 2022",
    view: "Leaf",
    image: leaf,
    middleImg: MidLeaf,
    bigImage: BigLeaf2,
    client: "Terry Spanser ",
    title: "Organic Betel Leaf",
    category: "Agriculture , Eco, Leaf",
    service: "Organic Products",
    text: "On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire",
  },
  {
    id: 4,
    date: "February 15, 2023",
    view: "Vegetable",
    image: tomato,
    middleImg: MidTomat,
    bigImage: tomato4,
    client: "Andy Craft",
    title: "Natural Tommato",
    category: "Agriculture , Eco, Vegetable",
    service: "Organic Products",
    text: "The wise man therefore always holds in these matters to this principle of selection: he rejects pleasures to secure other greater pleasures, or else he endures pains to avoid worse pains.",
  },
  {
    id: 5,
    date: "December 4, 2022",
    view: "Farmer",
    image: blackB,
    middleImg: BlackB,
    bigImage: BlackB,
    client: "Kevin Martin",
    title: "Black Raspberry",
    category: "Agriculture , Eco",
    service: "Organic Products",
    text: "Established fact that a reader will be distracted by the readable content of a page when looking a layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed ",
  },
  {
    id: 6,
    date: "December 26, 2022",
    view: "Fruits",
    image: limeTwo,
    middleImg: MidLime,
    bigImage: BigLim2,
    client: "Jesica Willy",
    title: "Honey Orange",
    category: "Agriculture , Eco, Fruits",
    service: "Organic Products",
    text: "Established fact that a reader will be distracted by the readable content of a page when looking a layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed ",
  },
];

export { porfolios };
